import {
  formEncode,
  getToken,
  handleResponse,
  nextFormDataApi,
  nextJsonApi,
} from '@/API/core';

const user = {
  getUsers: async () => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.get('/user', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default user;
